import strings from '../../Localization/Localization';

import { fetchCreditPacks } from '../../API/CreditPacks';
// import { phonePackage as phonePackagesRoutes } from '../Route/routes';

let creditPack = {
  fieldKey: "credit_pack",
  type: "dropdownEntity",
  label: strings.form.productCreditPack.creditPack.label,

  validators: [],

  // disabledLink: (value, getValues, getExtraValues) => {
  //   if(getExtraValues().credentials) {
  //     let credentials = getExtraValues().credentials();
  //     if(value && credentials.roles.includes('ROLE_CDR')) {
  //       return phonePackagesRoutes.routes.show.createPath(value["id"]);
  //     }
  //   }
  //   return false;
  // },

  showEmpty: true,
  loader: {
    id: "creditPacks",
    loader: fetchCreditPacks,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}


export const form = {
  formKey: "productCreditPacks",
  fields: [
    creditPack
  ]
}
